import type { AxiosResponse } from "axios";
import camelcaseKeys from "camelcase-keys";
import { axiosAccountInstance } from "@/utils/axios";
import type { PointHistories } from "@/features/common/PointHistory/type";

type Props = {
  offset: number;
  count: number;
};

export const getPointHistory = async (props: Props) => {
  const response: AxiosResponse<PointHistories> = await axiosAccountInstance.get("/api/point/history", {
    params: props,
  });

  return {
    pointHistories: camelcaseKeys(response.data, { deep: true }),
  };
};
